import { InjectionToken } from '@angular/core';
import { FeedbackDataConfig } from '@prlw/data/feedback/feedback-data.module';

export const FEEDBACK_DATA_CONFIG = new InjectionToken<FeedbackDataConfig>(
  'feedback-data-config',
);
